module.exports = __webpack_public_path__ + "img/1-2.705d18ba.png";